'use client';

import { useState } from 'react';
import { usePathname } from 'next/navigation';
import { Menu, X } from 'lucide-react';
import Link from 'next/link';
import { MarketingBrand } from '@/components/marketing/MarketingBrand';

const links = [
  { href: '/tools', label: 'Free tools' },
  { href: '/blogs', label: 'Blog' },
  { href: '/pricing', label: 'Pricing' },
  { href: 'https://plotsalot-docs.docsalot.dev/introduction', label: 'Docs' },
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();
  const navigation = links.map(link => (
    <Link
      key={link.href}
      href={link.href}
      aria-current={pathname?.startsWith(link.href) ? 'page' : undefined}
      onClick={() => setOpen(false)}>
      {link.label}
    </Link>
  ));

  return (
    <header className="marketing-nav marketing-theme">
      <nav className="marketing-nav-inner" aria-label="Main navigation">
        <MarketingBrand />
        <div className="marketing-nav-links">{navigation}</div>
        <div className="marketing-nav-actions">
          <Link href="/auth/signin">Log in</Link>
          <Link href="/chat" className="marketing-button marketing-button-white">
            Start for free
          </Link>
        </div>
        <button
          type="button"
          className="marketing-menu-toggle"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          aria-controls="marketing-mobile-menu"
          onClick={() => setOpen(value => !value)}>
          {open ? <X size={21} /> : <Menu size={21} />}
        </button>
        {open && (
          <div id="marketing-mobile-menu" className="marketing-mobile-menu">
            {navigation}
            <Link href="/auth/signin" onClick={() => setOpen(false)}>
              Log in
            </Link>
            <Link href="/chat" className="marketing-button" onClick={() => setOpen(false)}>
              Start for free
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
}
